// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ACCRETION_TALENT: {
    id: 407876,
    name: 'Accretion',
    icon: 'ability_evoker_accretion',
    maxRanks: 1,
    entryIds: [115530],
    definitionIds: [{ id: 120542, specId: 1473 }],
  },
  AERIAL_MASTERY_TALENT: {
    id: 365933,
    name: 'Aerial Mastery',
    icon: 'ability_evoker_aerialmastery',
    maxRanks: 1,
    entryIds: [115667],
    definitionIds: [{ id: 120679, specId: 1473 }],
  },
  AFTERIMAGE_TALENT: {
    id: 431875,
    name: 'Afterimage',
    icon: 'ability_evoker_livingflame',
    maxRanks: 1,
    entryIds: [117526],
    definitionIds: [{ id: 122538, specId: 1473 }],
  },
  ANACHRONISM_TALENT: {
    id: 407869,
    name: 'Anachronism',
    icon: 'ability_evoker_essenceburst6',
    maxRanks: 1,
    entryIds: [115523],
    definitionIds: [{ id: 120535, specId: 1473 }],
  },
  ANCIENT_FLAME_TALENT: {
    id: 369990,
    name: 'Ancient Flame',
    icon: 'inv_elemental_mote_fire01',
    maxRanks: 1,
    entryIds: [115577],
    definitionIds: [{ id: 120589, specId: 1473 }],
  },
  ANIMOSITY_TALENT: {
    id: 375797,
    name: 'Animosity',
    icon: 'spell_nature_shamanrage',
    maxRanks: 1,
    entryIds: [115642],
    definitionIds: [{ id: 120654, specId: 1467 }],
  },
  ARCANE_INTENSITY_TALENT: {
    id: 375618,
    name: 'Arcane Intensity',
    icon: 'ability_evoker_disintegrate',
    maxRanks: 2,
    entryIds: [115580],
    definitionIds: [{ id: 120592, specId: 1467 }],
  },
  ARCANE_REACH_TALENT: {
    id: 454983,
    name: 'Arcane Reach',
    icon: 'classicon_evoker',
    maxRanks: 1,
    entryIds: [115526],
    definitionIds: [{ id: 120538, specId: 1473 }],
  },
  ASHES_IN_MOTION_TALENT: {
    id: 1264365,
    name: 'Ashes in Motion',
    icon: 'inv_ability_flameshaperevoker_engulf',
    maxRanks: 1,
    entryIds: [123416],
    definitionIds: [{ id: 128254, specId: 1468 }],
  },
  ASPECTS_FAVOR_TALENT: {
    id: 407243,
    name: "Aspects' Favor",
    icon: 'ability_evoker_aspectsfavor',
    maxRanks: 2,
    entryIds: [115517],
    definitionIds: [{ id: 120529, specId: 1473 }],
  },
  ATTUNED_TO_THE_DREAM_TALENT: {
    id: 376930,
    name: 'Attuned to the Dream',
    icon: 'ability_rogue_imrovedrecuperate',
    maxRanks: 2,
    entryIds: [115600],
    definitionIds: [{ id: 120612, specId: 1473 }],
  },
  AZURE_CELERITY_TALENT: {
    id: 1219723,
    name: 'Azure Celerity',
    icon: 'ability_evoker_masterylifebinder_blue',
    maxRanks: 1,
    entryIds: [115637],
    definitionIds: [{ id: 120649, specId: 1467 }],
  },
  AZURE_ESSENCE_BURST_TALENT: {
    id: 375721,
    name: 'Azure Essence Burst',
    icon: 'ability_evoker_essenceburst2',
    maxRanks: 1,
    entryIds: [115646],
    definitionIds: [{ id: 120658, specId: 1467 }],
  },
  AZURE_SWEEP_TALENT: {
    id: 1265867,
    name: 'Azure Sweep',
    icon: 'inv_10_skinning_dragonscales_blue',
    maxRanks: 1,
    entryIds: [115579],
    definitionIds: [{ id: 120591, specId: 1467 }],
  },
  BESTOW_WEYRNSTONE_TALENT: {
    id: 408233,
    name: 'Bestow Weyrnstone',
    icon: 'ability_evoker_bestowweyrnstone',
    maxRanks: 1,
    entryIds: [115534],
    definitionIds: [{ id: 120546, specId: 1473 }],
  },
  BLAST_FURNACE_TALENT: {
    id: 375510,
    name: 'Blast Furnace',
    icon: 'ability_evoker_firebreath',
    maxRanks: 1,
    entryIds: [115618],
    definitionIds: [{ id: 120630, specId: 1473 }],
  },
  BLISTERING_SCALES_TALENT: {
    id: 360827,
    name: 'Blistering Scales',
    icon: 'ability_evoker_blisteringscales',
    maxRanks: 1,
    entryIds: [115508],
    definitionIds: [{ id: 120520, specId: 1473 }],
  },
  BOMBARDMENTS_TALENT: {
    id: 434300,
    name: 'Bombardments',
    icon: 'inv_ability_scalecommanderevoker_bombardments',
    maxRanks: 1,
    entryIds: [117533],
    definitionIds: [{ id: 122545, specId: 1473 }],
  },
  BOUNTIFUL_BLOOM_TALENT: {
    id: 370886,
    name: 'Bountiful Bloom',
    icon: 'ability_evoker_emeraldblossom',
    maxRanks: 1,
    entryIds: [115599],
    definitionIds: [{ id: 120611, specId: 1473 }],
  },
  BREATH_OF_EONS_TALENT: {
    id: 403631,
    name: 'Breath of Eons',
    icon: 'ability_evoker_breathofeons',
    maxRanks: 1,
    entryIds: [115536],
    definitionIds: [{ id: 120548, specId: 1473 }],
  },
  BURNING_ADRENALINE_TALENT: {
    id: 444020,
    name: 'Burning Adrenaline',
    icon: 'inv_gauntlets_03',
    maxRanks: 1,
    entryIds: [117543],
    definitionIds: [{ id: 122555, specId: 1468 }],
  },
  BURNOUT_TALENT: {
    id: 375801,
    name: 'Burnout',
    icon: 'spell_fire_soulburn',
    maxRanks: 1,
    entryIds: [115624],
    definitionIds: [{ id: 120636, specId: 1467 }],
  },
  CALL_OF_YSERA_TALENT: {
    id: 373834,
    name: 'Call of Ysera',
    icon: 'inv_drakemountemerald',
    maxRanks: 1,
    entryIds: [115554],
    definitionIds: [{ id: 120566, specId: 1468 }],
  },
  CATALYZE_TALENT: {
    id: 386283,
    name: 'Catalyze',
    icon: 'spell_fire_masterofelements',
    maxRanks: 1,
    entryIds: [115587],
    definitionIds: [{ id: 120599, specId: 1467 }],
  },
  CAUSALITY_TALENT: {
    id: 375777,
    name: 'Causality',
    icon: 'spell_azerite_essence_16',
    maxRanks: 1,
    entryIds: [115683],
    definitionIds: [{ id: 120695, specId: 1467 }],
  },
  CAUTERIZING_FLAME_TALENT: {
    id: 374251,
    name: 'Cauterizing Flame',
    icon: 'ability_evoker_fontofmagic_red',
    maxRanks: 1,
    entryIds: [115602],
    definitionIds: [{ id: 120614, specId: 1473 }],
    manaCost: 3500,
  },
  CHARGED_BLAST_TALENT: {
    id: 370455,
    name: 'Charged Blast',
    icon: 'spell_arcane_arcanepotency',
    maxRanks: 1,
    entryIds: [115628],
    definitionIds: [{ id: 120640, specId: 1467 }],
  },
  CHRONAL_DYNAMO_TALENT: {
    id: 1291522,
    name: 'Chronal Dynamo',
    icon: 'inv_10_dungeonjewelry_dragon_trinket_1arcanemagical_red',
    maxRanks: 1,
    entryIds: [135742],
    definitionIds: [{ id: 140497, specId: 1473 }],
  },
  CHRONOBOON_TALENT: {
    id: 1260484,
    name: 'Chronoboon',
    icon: 'ability_evoker_tipthescales',
    maxRanks: 1,
    entryIds: [135743],
    definitionIds: [{ id: 140498, specId: 1473 }],
  },
  CHRONO_FLAME_TALENT: {
    id: 431442,
    name: 'Chrono Flame',
    icon: 'inv_ability_chronowardenevoker_chronoflame',
    maxRanks: 1,
    entryIds: [117551],
    definitionIds: [{ id: 122563, specId: 1473 }],
  },
  CHRONO_WARD_TALENT: {
    id: 409676,
    name: 'Chrono Ward',
    icon: 'ability_evoker_bronze_01',
    maxRanks: 1,
    entryIds: [115706],
    definitionIds: [{ id: 120718, specId: 1473 }],
  },
  CLAIRVOYANT_TALENT: {
    id: 1250914,
    name: 'Clairvoyant',
    icon: 'ability_evoker_masterylifebinder_bronze',
    maxRanks: 1,
    entryIds: [115528],
    definitionIds: [{ id: 120540, specId: 1473 }],
  },
  CLOBBERING_SWEEP_TALENT: {
    id: 375443,
    name: 'Clobbering Sweep',
    icon: 'ability_racial_tailswipe',
    maxRanks: 1,
    entryIds: [128217],
    definitionIds: [{ id: 133024, specId: 1473 }],
  },
  COMMAND_SQUADRON_TALENT: {
    id: 1260745,
    name: 'Command Squadron',
    icon: 'ability_dragonriding_dynamicflight01',
    maxRanks: 1,
    entryIds: [136053],
    definitionIds: [{ id: 140808, specId: 1473 }],
  },
  CONCENTRATED_POWER_TALENT: {
    id: 1261448,
    name: 'Concentrated Power',
    icon: 'inv_10_dungeonjewelry_dragon_trinket_1arcanemagical_blue',
    maxRanks: 1,
    entryIds: [136052],
    definitionIds: [{ id: 140807, specId: 1473 }],
  },
  CONDUIT_OF_FLAME_TALENT: {
    id: 444843,
    name: 'Conduit of Flame',
    icon: 'ability_evoker_innatemagic5',
    maxRanks: 1,
    entryIds: [117546],
    definitionIds: [{ id: 122558, specId: 1468 }],
  },
  CONSUME_FLAME_TALENT: {
    id: 444088,
    name: 'Consume Flame',
    icon: 'inv_shadowflames_wave',
    maxRanks: 1,
    entryIds: [117519],
    definitionIds: [{ id: 122531, specId: 1468 }],
  },
  DEEP_EXHALATION_TALENT: {
    id: 1264321,
    name: 'Deep Exhalation',
    icon: 'ability_evoker_firebreath',
    maxRanks: 1,
    entryIds: [117542],
    definitionIds: [{ id: 122554, specId: 1468 }],
  },
  DEFY_FATE_TALENT: {
    id: 404195,
    name: 'Defy Fate',
    icon: 'ability_evoker_defyfate',
    maxRanks: 1,
    entryIds: [115522],
    definitionIds: [{ id: 120534, specId: 1473 }],
  },
  DELAY_HARM_TALENT: {
    id: 376207,
    name: 'Delay Harm',
    icon: 'ability_racial_magicalresistance',
    maxRanks: 1,
    entryIds: [115649],
    definitionIds: [{ id: 120661, specId: 1468 }],
  },
  DIVERTED_POWER_TALENT: {
    id: 441219,
    name: 'Diverted Power',
    icon: 'ability_evoker_powerswell',
    maxRanks: 1,
    entryIds: [120124],
    definitionIds: [{ id: 125024, specId: 1473 }],
  },
  DOUBLE_TIME_TALENT: {
    id: 431874,
    name: 'Double-time',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 1,
    entryIds: [117529],
    definitionIds: [{ id: 122541, specId: 1473 }],
  },
  DRACONIC_ATTUNEMENTS_TALENT: {
    id: 403208,
    name: 'Draconic Attunements',
    icon: 'ability_evoker_draconicattunements',
    maxRanks: 1,
    entryIds: [115518],
    definitionIds: [{ id: 120530, specId: 1473 }],
  },
  DRACONIC_INSTINCTS_TALENT: {
    id: 445958,
    name: 'Draconic Instincts',
    icon: 'inv_misc_scales_basilliskorange',
    maxRanks: 1,
    entryIds: [123405],
    definitionIds: [{ id: 128243, specId: 1468 }],
  },
  DRACONIC_LEGACY_TALENT: {
    id: 376166,
    name: 'Draconic Legacy',
    icon: 'inv_helm_mail_dracthyrquest_b_02',
    maxRanks: 1,
    entryIds: [115609],
    definitionIds: [{ id: 120621, specId: 1473 }],
  },
  DRAGONRAGE_TALENT: {
    id: 375087,
    name: 'Dragonrage',
    icon: 'ability_evoker_dragonrage',
    maxRanks: 1,
    entryIds: [115643],
    definitionIds: [{ id: 120655, specId: 1467 }],
  },
  DREAM_BREATH_TALENT: {
    id: 355936,
    name: 'Dream Breath',
    icon: 'ability_evoker_dreambreath',
    maxRanks: 1,
    entryIds: [115542],
    definitionIds: [{ id: 120554, specId: 1468 }],
    manaCost: 12250,
  },
  DREAM_FLIGHT_TALENT: {
    id: 359816,
    name: 'Dream Flight',
    icon: 'ability_evoker_dreamflight',
    maxRanks: 1,
    entryIds: [115573],
    definitionIds: [{ id: 120585, specId: 1468 }],
    manaCost: 10000,
  },
  DREAM_OF_SPRING_TALENT: {
    id: 414969,
    name: 'Dream of Spring',
    icon: 'ability_evoker_masterylifebinder',
    maxRanks: 1,
    entryIds: [115881],
    definitionIds: [{ id: 120893, specId: 1473 }],
  },
  DREAM_SIMULACRUM_TALENT: {
    id: 1241669,
    name: 'Dream Simulacrum',
    icon: 'ability_evoker_dragonrage2_green',
    maxRanks: 1,
    entryIds: [115546],
    definitionIds: [{ id: 120558, specId: 1468 }],
  },
  DUPLICATE_1_AUGMENTATION_TALENT: {
    id: 1259173,
    name: 'Duplicate',
    icon: 'inv12_apextalent_evoker_duplicate',
    maxRanks: 1,
    entryIds: [137013],
    definitionIds: [{ id: 141776, specId: 1473 }],
  },
  DUPLICATE_2_AUGMENTATION_TALENT: {
    id: 1259174,
    name: 'Duplicate',
    icon: 'ability_evoker_masterytimewalker',
    maxRanks: 2,
    entryIds: [137012],
    definitionIds: [{ id: 141775, specId: 1473 }],
  },
  DUPLICATE_3_AUGMENTATION_TALENT: {
    id: 1259175,
    name: 'Duplicate',
    icon: 'ability_evoker_ouroboros',
    maxRanks: 1,
    entryIds: [137011],
    definitionIds: [{ id: 141774, specId: 1473 }],
  },
  EBON_MIGHT_TALENT: {
    id: 395152,
    name: 'Ebon Might',
    icon: 'spell_sarkareth',
    maxRanks: 1,
    entryIds: [115496],
    definitionIds: [{ id: 120508, specId: 1473 }],
    manaCost: 2500,
  },
  ECHOING_STRIKE_TALENT: {
    id: 410784,
    name: 'Echoing Strike',
    icon: 'ability_evoker_echoingstrike',
    maxRanks: 1,
    entryIds: [115680],
    definitionIds: [{ id: 120692, specId: 1473 }],
  },
  ECHO_TALENT: {
    id: 364343,
    name: 'Echo',
    icon: 'ability_evoker_echo',
    maxRanks: 1,
    entryIds: [115653],
    definitionIds: [{ id: 120665, specId: 1468 }],
    essenceCost: 2,
    manaCost: 4750,
  },
  EMPATH_TALENT: {
    id: 376138,
    name: 'Empath',
    icon: 'ability_evoker_powernexus2',
    maxRanks: 1,
    entryIds: [115545],
    definitionIds: [{ id: 120557, specId: 1468 }],
  },
  ENERGY_LOOP_TALENT: {
    id: 372233,
    name: 'Energy Loop',
    icon: 'inv_elemental_mote_mana',
    maxRanks: 1,
    entryIds: [115566],
    definitionIds: [{ id: 120578, specId: 1468 }],
  },
  ENGULFING_BLAZE_TALENT: {
    id: 370837,
    name: 'Engulfing Blaze',
    icon: 'inv_inscription_pigment_ruby',
    maxRanks: 1,
    entryIds: [115585],
    definitionIds: [{ id: 120597, specId: 1467 }],
  },
  ENKINDLED_TALENT: {
    id: 375554,
    name: 'Enkindled',
    icon: 'ability_evoker_livingflame',
    maxRanks: 2,
    entryIds: [115603],
    definitionIds: [{ id: 120615, specId: 1473 }],
  },
  ENKINDLE_TALENT: {
    id: 444016,
    name: 'Enkindle',
    icon: 'inv_10_elementalcombinedfoozles_purifiedshadowflame',
    maxRanks: 1,
    entryIds: [117553],
    definitionIds: [{ id: 122565, specId: 1468 }],
  },
  ERUPTION_TALENT: {
    id: 395160,
    name: 'Eruption',
    icon: 'ability_evoker_eruption',
    maxRanks: 1,
    entryIds: [115498],
    definitionIds: [{ id: 120510, specId: 1473 }],
    essenceCost: 3,
  },
  ESSENCE_ATTUNEMENT_TALENT: {
    id: 375722,
    name: 'Essence Attunement',
    icon: 'ability_evoker_essenceburststacks',
    maxRanks: 1,
    entryIds: [115631, 115540, 115519],
    definitionIds: [
      { id: 120643, specId: 1467 },
      { id: 120552, specId: 1468 },
      { id: 120531, specId: 1473 },
    ],
  },
  ESSENCE_BURST_AUGMENTATION_TALENT: {
    id: 396187,
    name: 'Essence Burst',
    icon: 'ability_evoker_essenceburst',
    maxRanks: 1,
    entryIds: [115520],
    definitionIds: [{ id: 120532, specId: 1473 }],
  },
  ESSENCE_BURST_PRESERVATION_TALENT: {
    id: 369297,
    name: 'Essence Burst',
    icon: 'ability_evoker_essenceburst',
    maxRanks: 1,
    entryIds: [115541],
    definitionIds: [{ id: 120553, specId: 1468 }],
  },
  ESSENCE_WELL_TALENT: {
    id: 1265993,
    name: 'Essence Well',
    icon: 'ability_evoker_essenceburst4',
    maxRanks: 1,
    entryIds: [136055],
    definitionIds: [{ id: 140810, specId: 1468 }],
  },
  ETERNITYS_SPAN_TALENT: {
    id: 375757,
    name: "Eternity's Span",
    icon: 'spell_arcane_arcanetorrent',
    maxRanks: 1,
    entryIds: [115632],
    definitionIds: [{ id: 120644, specId: 1467 }],
  },
  ETERNITY_SURGE_TALENT: {
    id: 359073,
    name: 'Eternity Surge',
    icon: 'ability_evoker_eternitysurge',
    maxRanks: 1,
    entryIds: [115581],
    definitionIds: [{ id: 120593, specId: 1467 }],
  },
  EVENT_HORIZON_TALENT: {
    id: 411164,
    name: 'Event Horizon',
    icon: 'ability_priest_cascade_shadow',
    maxRanks: 1,
    entryIds: [115629],
    definitionIds: [{ id: 120641, specId: 1467 }],
  },
  EXHILARATING_BURST_TALENT: {
    id: 377100,
    name: 'Exhilarating Burst',
    icon: 'ability_evoker_essenceburst3',
    maxRanks: 2,
    entryIds: [115550],
    definitionIds: [{ id: 120562, specId: 1468 }],
  },
  EXPANDED_LUNGS_TALENT: {
    id: 444845,
    name: 'Expanded Lungs',
    icon: 'inv_fyrakk_dragonbreath',
    maxRanks: 1,
    entryIds: [128713],
    definitionIds: [{ id: 133515, specId: 1468 }],
  },
  EXPUNGE_TALENT: {
    id: 365585,
    name: 'Expunge',
    icon: 'ability_evoker_fontofmagic_green',
    maxRanks: 1,
    entryIds: [115615],
    definitionIds: [{ id: 120627, specId: 1473 }],
    manaCost: 25000,
  },
  EXTENDED_BATTLE_TALENT: {
    id: 441212,
    name: 'Extended Battle',
    icon: 'ability_evoker_divideandconquer',
    maxRanks: 1,
    entryIds: [117525],
    definitionIds: [{ id: 122537, specId: 1473 }],
  },
  EXTENDED_FLIGHT_TALENT: {
    id: 375517,
    name: 'Extended Flight',
    icon: 'ability_evoker_hover',
    maxRanks: 2,
    entryIds: [115664],
    definitionIds: [{ id: 120676, specId: 1473 }],
  },
  EXUBERANCE_TALENT: {
    id: 375542,
    name: 'Exuberance',
    icon: 'ability_evoker_hover2',
    maxRanks: 1,
    entryIds: [115608],
    definitionIds: [{ id: 120620, specId: 1473 }],
  },
  EYE_OF_INFINITY_TALENT: {
    id: 411165,
    name: 'Eye of Infinity',
    icon: 'ability_evoker_dragonrage2_blue',
    maxRanks: 1,
    entryIds: [115630],
    definitionIds: [{ id: 120642, specId: 1467 }],
  },
  FATE_MIRROR_TALENT: {
    id: 412774,
    name: 'Fate Mirror',
    icon: 'trade_archaeology_highbornesoulmirror',
    maxRanks: 1,
    entryIds: [115685],
    definitionIds: [{ id: 120697, specId: 1473 }],
  },
  FEED_THE_FLAMES_TALENT: {
    id: 369846,
    name: 'Feed the Flames',
    icon: 'mace_1h_blacksmithing_d_04_icon',
    maxRanks: 1,
    entryIds: [115584],
    definitionIds: [{ id: 120596, specId: 1467 }],
  },
  FIELD_OF_DREAMS_TALENT: {
    id: 370062,
    name: 'Field of Dreams',
    icon: 'inv_misc_herb_chamlotus',
    maxRanks: 1,
    entryIds: [115552],
    definitionIds: [{ id: 120564, specId: 1468 }],
  },
  FIRE_TORRENT_TALENT: {
    id: 1265992,
    name: 'Fire Torrent',
    icon: 'spell_shaman_stormearthfire',
    maxRanks: 1,
    entryIds: [136054],
    definitionIds: [{ id: 140809, specId: 1468 }],
  },
  FLOW_STATE_TALENT: {
    id: 385696,
    name: 'Flow State',
    icon: 'ability_evoker_timespiral',
    maxRanks: 2,
    entryIds: [115560],
    definitionIds: [{ id: 120572, specId: 1468 }],
  },
  FLUTTERING_SEEDLINGS_TALENT: {
    id: 359793,
    name: 'Fluttering Seedlings',
    icon: 'inv_herbalism_70_yserallineseed',
    maxRanks: 2,
    entryIds: [115551],
    definitionIds: [{ id: 120563, specId: 1468 }],
  },
  FOCI_OF_LIFE_TALENT: {
    id: 375574,
    name: 'Foci of Life',
    icon: 'spell_fire_incinerate',
    maxRanks: 1,
    entryIds: [115660],
    definitionIds: [{ id: 120672, specId: 1473 }],
  },
  FONT_OF_MAGIC_AUGMENTATION_TALENT: {
    id: 408083,
    name: 'Font of Magic',
    icon: 'ability_evoker_fontofmagic',
    maxRanks: 1,
    entryIds: [115532],
    definitionIds: [{ id: 120544, specId: 1473 }],
  },
  FONT_OF_MAGIC_DEVASTATION_TALENT: {
    id: 411212,
    name: 'Font of Magic',
    icon: 'ability_evoker_fontofmagic',
    maxRanks: 1,
    entryIds: [115586],
    definitionIds: [{ id: 120598, specId: 1467 }],
  },
  FONT_OF_MAGIC_PRESERVATION_TALENT: {
    id: 375783,
    name: 'Font of Magic',
    icon: 'ability_evoker_fontofmagic',
    maxRanks: 1,
    entryIds: [115556],
    definitionIds: [{ id: 120568, specId: 1468 }],
  },
  FORGER_OF_MOUNTAINS_TALENT: {
    id: 375528,
    name: 'Forger of Mountains',
    icon: 'ability_earthen_pillar',
    maxRanks: 1,
    entryIds: [115576],
    definitionIds: [{ id: 120588, specId: 1473 }],
  },
  FULMINOUS_ROAR_TALENT: {
    id: 1218447,
    name: 'Fulminous Roar',
    icon: 'ability_evoker_oppressingroar2',
    maxRanks: 1,
    entryIds: [117520],
    definitionIds: [{ id: 122532, specId: 1468 }],
  },
  GOLDEN_HOUR_TALENT: {
    id: 378196,
    name: 'Golden Hour',
    icon: 'inv_belt_armor_waistoftime_d_01',
    maxRanks: 1,
    entryIds: [115559],
    definitionIds: [{ id: 120571, specId: 1468 }],
  },
  GOLDEN_OPPORTUNITY_TALENT: {
    id: 432004,
    name: 'Golden Opportunity',
    icon: 'achievement_faction_goldenlotus',
    maxRanks: 1,
    entryIds: [117539],
    definitionIds: [{ id: 122551, specId: 1473 }],
  },
  GRACE_PERIOD_TALENT: {
    id: 376239,
    name: 'Grace Period',
    icon: 'ability_evoker_reversion_green',
    maxRanks: 1,
    entryIds: [115565],
    definitionIds: [{ id: 120577, specId: 1468 }],
  },
  HARDENED_SCALES_TALENT: {
    id: 441180,
    name: 'Hardened Scales',
    icon: 'inv_10_skinning_scales_black',
    maxRanks: 1,
    entryIds: [117530],
    definitionIds: [{ id: 122542, specId: 1473 }],
  },
  HEAT_WAVE_TALENT: {
    id: 375725,
    name: 'Heat Wave',
    icon: 'spell_fire_moltenblood',
    maxRanks: 2,
    entryIds: [115588],
    definitionIds: [{ id: 120600, specId: 1467 }],
  },
  HEAVY_WINGBEATS_TALENT: {
    id: 368838,
    name: 'Heavy Wingbeats',
    icon: 'ability_racial_wingbuffet',
    maxRanks: 1,
    entryIds: [128216],
    definitionIds: [{ id: 133023, specId: 1473 }],
  },
  HOARDED_POWER_TALENT: {
    id: 375796,
    name: 'Hoarded Power',
    icon: 'ability_evoker_innatemagic2',
    maxRanks: 1,
    entryIds: [115512],
    definitionIds: [{ id: 120524, specId: 1473 }],
  },
  HONED_AGGRESSION_TALENT: {
    id: 371038,
    name: 'Honed Aggression',
    icon: 'spell_fire_blueimmolation',
    maxRanks: 2,
    entryIds: [115641],
    definitionIds: [{ id: 120653, specId: 1467 }],
  },
  IGNITION_RUSH_TALENT: {
    id: 408775,
    name: 'Ignition Rush',
    icon: 'spell_fire_immolation',
    maxRanks: 1,
    entryIds: [115688],
    definitionIds: [{ id: 120700, specId: 1473 }],
  },
  IMMINENT_DESTRUCTION_AUGMENTATION_TALENT: {
    id: 459537,
    name: 'Imminent Destruction',
    icon: 'spell_burningbladeshaman_blazing_radiance',
    maxRanks: 1,
    entryIds: [126304],
    definitionIds: [{ id: 131130, specId: 1473 }],
  },
  IMMINENT_DESTRUCTION_DEVASTATION_TALENT: {
    id: 370781,
    name: 'Imminent Destruction',
    icon: 'spell_burningbladeshaman_blazing_radiance',
    maxRanks: 1,
    entryIds: [115638],
    definitionIds: [{ id: 120650, specId: 1467 }],
  },
  IMPROVED_DEFY_FATE_TALENT: {
    id: 1268881,
    name: 'Improved Defy Fate',
    icon: 'ability_evoker_masterytimewalker',
    maxRanks: 1,
    entryIds: [115493],
    definitionIds: [{ id: 120505, specId: 1473 }],
  },
  INFERNOS_BLESSING_TALENT: {
    id: 410261,
    name: "Inferno's Blessing",
    icon: 'ability_evoker_infernosblessing',
    maxRanks: 1,
    entryIds: [115495],
    definitionIds: [{ id: 120507, specId: 1473 }],
  },
  INHERENT_RESISTANCE_TALENT: {
    id: 375544,
    name: 'Inherent Resistance',
    icon: 'inv_misc_rubysanctum1',
    maxRanks: 2,
    entryIds: [115670],
    definitionIds: [{ id: 120682, specId: 1473 }],
  },
  INNATE_MAGIC_TALENT: {
    id: 375520,
    name: 'Innate Magic',
    icon: 'ability_evoker_innatemagic4',
    maxRanks: 2,
    entryIds: [115611],
    definitionIds: [{ id: 120623, specId: 1473 }],
  },
  INNER_FLAME_TALENT: {
    id: 1242745,
    name: 'Inner Flame',
    icon: 'ability_evoker_infernosblessing',
    maxRanks: 1,
    entryIds: [115572],
    definitionIds: [{ id: 120584, specId: 1468 }],
  },
  INNER_RADIANCE_TALENT: {
    id: 386405,
    name: 'Inner Radiance',
    icon: 'spell_holy_spellwarding',
    maxRanks: 1,
    entryIds: [115620],
    definitionIds: [{ id: 120632, specId: 1473 }],
  },
  INSTABILITY_MATRIX_TALENT: {
    id: 431484,
    name: 'Instability Matrix',
    icon: 'ability_dragonriding_bronzerewind01',
    maxRanks: 1,
    entryIds: [126310],
    definitionIds: [{ id: 131136, specId: 1473 }],
  },
  INSTINCTIVE_ARCANA_TALENT: {
    id: 376164,
    name: 'Instinctive Arcana',
    icon: 'spell_arcane_studentofmagic',
    maxRanks: 2,
    entryIds: [115619],
    definitionIds: [{ id: 120631, specId: 1473 }],
  },
  INTERWOVEN_THREADS_TALENT: {
    id: 412713,
    name: 'Interwoven Threads',
    icon: 'inv_enchant_optionalreagent_01',
    maxRanks: 1,
    entryIds: [115686],
    definitionIds: [{ id: 120698, specId: 1473 }],
  },
  IRIDESCENCE_TALENT: {
    id: 370867,
    name: 'Iridescence',
    icon: 'ability_evoker_powerswell',
    maxRanks: 1,
    entryIds: [115633],
    definitionIds: [{ id: 120645, specId: 1467 }],
  },
  JUST_IN_TIME_TALENT: {
    id: 376204,
    name: 'Just in Time',
    icon: 'inv_offhand_1h_artifactsilverhand_d_01',
    maxRanks: 1,
    entryIds: [115648],
    definitionIds: [{ id: 120660, specId: 1468 }],
  },
  LANDSLIDE_TALENT: {
    id: 358385,
    name: 'Landslide',
    icon: 'ability_earthen_pillar',
    maxRanks: 1,
    entryIds: [115614],
    definitionIds: [{ id: 120626, specId: 1473 }],
    manaCost: 3500,
  },
  LAY_WASTE_TALENT: {
    id: 371034,
    name: 'Lay Waste',
    icon: 'ability_evoker_deepbreath',
    maxRanks: 1,
    entryIds: [115592],
    definitionIds: [{ id: 120604, specId: 1467 }],
  },
  LEAPING_FLAMES_TALENT: {
    id: 369939,
    name: 'Leaping Flames',
    icon: 'ability_evoker_pupilofalexstraza',
    maxRanks: 1,
    entryIds: [115657],
    definitionIds: [{ id: 120669, specId: 1473 }],
  },
  LEGACY_OF_THE_LIFEBINDER_TALENT: {
    id: 1264269,
    name: 'Legacy of the Lifebinder',
    icon: 'ability_evoker_dragonrage2',
    maxRanks: 1,
    entryIds: [117547],
    definitionIds: [{ id: 122559, specId: 1468 }],
  },
  LIFEBIND_TALENT: {
    id: 373270,
    name: 'Lifebind',
    icon: 'ability_evoker_hoverred',
    maxRanks: 1,
    entryIds: [115557],
    definitionIds: [{ id: 120569, specId: 1468 }],
  },
  LIFECINDERS_TALENT: {
    id: 444322,
    name: 'Lifecinders',
    icon: 'inv_misc_herb_cinderbloom_petal',
    maxRanks: 1,
    entryIds: [117528],
    definitionIds: [{ id: 122540, specId: 1468 }],
  },
  LIFEFORCE_MENDER_TALENT: {
    id: 376179,
    name: 'Lifeforce Mender',
    icon: 'ability_evoker_dragonrage2',
    maxRanks: 2,
    entryIds: [115538],
    definitionIds: [{ id: 120550, specId: 1468 }],
  },
  LIFESPARK_TALENT: {
    id: 443177,
    name: 'Lifespark',
    icon: 'ability_evoker_masterylifebinder_red',
    maxRanks: 1,
    entryIds: [123294],
    definitionIds: [{ id: 128172, specId: 1468 }],
  },
  LIFE_GIVERS_FLAME_TALENT: {
    id: 371426,
    name: "Life-Giver's Flame",
    icon: 'item_sparkofragnoros',
    maxRanks: 1,
    entryIds: [115539],
    definitionIds: [{ id: 120551, specId: 1468 }],
  },
  LUSH_GROWTH_TALENT: {
    id: 375561,
    name: 'Lush Growth',
    icon: 'inv_staff_2h_bloodelf_c_01',
    maxRanks: 2,
    entryIds: [115662],
    definitionIds: [{ id: 120674, specId: 1473 }],
  },
  MANEUVERABILITY_TALENT: {
    id: 433871,
    name: 'Maneuverability',
    icon: 'ability_evoker_deepbreath',
    maxRanks: 1,
    entryIds: [117538],
    definitionIds: [{ id: 122550, specId: 1473 }],
  },
  MASS_DISINTEGRATE_TALENT: {
    id: 436335,
    name: 'Mass Disintegrate',
    icon: 'inv_1205_ability_evoker_massdisintegration',
    maxRanks: 1,
    entryIds: [117536],
    definitionIds: [{ id: 122548, specId: 1467 }],
  },
  MASS_ERUPTION_TALENT: {
    id: 438587,
    name: 'Mass Eruption',
    icon: 'ability_evoker_eruption',
    maxRanks: 1,
    entryIds: [122279],
    definitionIds: [{ id: 127179, specId: 1473 }],
  },
  MELT_ARMOR_TALENT: {
    id: 441176,
    name: 'Melt Armor',
    icon: 'inv_10_gearupgrade_drakesshadowflameenhancedcrest',
    maxRanks: 1,
    entryIds: [117518],
    definitionIds: [{ id: 122530, specId: 1473 }],
  },
  MENACING_PRESENCE_TALENT: {
    id: 441181,
    name: 'Menacing Presence',
    icon: 'ability_racial_wingbuffet',
    maxRanks: 1,
    entryIds: [120125],
    definitionIds: [{ id: 125025, specId: 1473 }],
  },
  MERITHRAS_BLESSING_1_PRESERVATION_TALENT: {
    id: 1256577,
    name: "Merithra's Blessing",
    icon: 'inv12_apextalent_evoker_merithrasblessing',
    maxRanks: 1,
    entryIds: [137007],
    definitionIds: [{ id: 141770, specId: 1468 }],
  },
  MERITHRAS_BLESSING_2_PRESERVATION_TALENT: {
    id: 1256682,
    name: "Merithra's Blessing",
    icon: 'ability_evoker_reversion_green',
    maxRanks: 2,
    entryIds: [137006],
    definitionIds: [{ id: 141769, specId: 1468 }],
  },
  MERITHRAS_BLESSING_3_PRESERVATION_TALENT: {
    id: 1256689,
    name: "Merithra's Blessing",
    icon: 'ability_evoker_giftoftheaspects',
    maxRanks: 1,
    entryIds: [137005],
    definitionIds: [{ id: 141768, specId: 1468 }],
  },
  MIGHTY_INFERNO_TALENT: {
    id: 1291457,
    name: 'Mighty Inferno',
    icon: 'ability_warlock_burningembers',
    maxRanks: 1,
    entryIds: [126305],
    definitionIds: [{ id: 131131, specId: 1473 }],
  },
  MIGHT_OF_THE_BLACK_DRAGONFLIGHT_TALENT: {
    id: 441705,
    name: 'Might of the Black Dragonflight',
    icon: 'ability_evoker_blackattunementalt',
    maxRanks: 1,
    entryIds: [117549],
    definitionIds: [{ id: 122561, specId: 1473 }],
  },
  MOLTEN_BLOOD_TALENT: {
    id: 410643,
    name: 'Molten Blood',
    icon: 'spell_shaman_spewlava',
    maxRanks: 1,
    entryIds: [115510],
    definitionIds: [{ id: 120522, specId: 1473 }],
  },
  MOMENTUM_SHIFT_TALENT: {
    id: 408004,
    name: 'Momentum Shift',
    icon: 'ability_priest_voidshift',
    maxRanks: 1,
    entryIds: [115506],
    definitionIds: [{ id: 120518, specId: 1473 }],
  },
  MOTES_OF_ACCELERATION_TALENT: {
    id: 432008,
    name: 'Motes of Acceleration',
    icon: 'item_timemote_icon',
    maxRanks: 1,
    entryIds: [117784],
    definitionIds: [{ id: 122796, specId: 1473 }],
  },
  MOTES_OF_POSSIBILITY_TALENT: {
    id: 409267,
    name: 'Motes of Possibility',
    icon: 'ability_evoker_motesofpossibility',
    maxRanks: 1,
    entryIds: [115531],
    definitionIds: [{ id: 120543, specId: 1473 }],
  },
  NATURAL_CONVERGENCE_TALENT: {
    id: 369913,
    name: 'Natural Convergence',
    icon: 'spell_frost_frostblast',
    maxRanks: 1,
    entryIds: [115621],
    definitionIds: [{ id: 120633, specId: 1473 }],
  },
  NIMBLE_FLYER_TALENT: {
    id: 441253,
    name: 'Nimble Flyer',
    icon: 'ability_evoker_hover',
    maxRanks: 1,
    entryIds: [117540],
    definitionIds: [{ id: 122552, specId: 1473 }],
  },
  NOZDORMUS_TEACHINGS_TALENT: {
    id: 376237,
    name: "Nozdormu's Teachings",
    icon: 'inv_misc_head_dragon_bronze',
    maxRanks: 1,
    entryIds: [115562],
    definitionIds: [{ id: 120574, specId: 1468 }],
  },
  NOZDORMU_ADEPT_TALENT: {
    id: 431715,
    name: 'Nozdormu Adept',
    icon: 'ability_evoker_aspectsfavorbronze',
    maxRanks: 1,
    entryIds: [117544],
    definitionIds: [{ id: 122556, specId: 1473 }],
  },
  OBSIDIAN_BULWARK_TALENT: {
    id: 375406,
    name: 'Obsidian Bulwark',
    icon: 'inv_shield_1h_revenantfire_d_01',
    maxRanks: 1,
    entryIds: [115597],
    definitionIds: [{ id: 120609, specId: 1473 }],
  },
  OBSIDIAN_SCALES_TALENT: {
    id: 363916,
    name: 'Obsidian Scales',
    icon: 'inv_artifact_dragonscales',
    maxRanks: 1,
    entryIds: [115613],
    definitionIds: [{ id: 120625, specId: 1473 }],
  },
  ONSLAUGHT_TALENT: {
    id: 441245,
    name: 'Onslaught',
    icon: 'spell_fire_soulburn',
    maxRanks: 1,
    entryIds: [117541],
    definitionIds: [{ id: 122553, specId: 1473 }],
  },
  ONYX_LEGACY_TALENT: {
    id: 386348,
    name: 'Onyx Legacy',
    icon: 'inv_misc_head_dragon_black',
    maxRanks: 1,
    entryIds: [115639],
    definitionIds: [{ id: 120651, specId: 1467 }],
  },
  OPPRESSING_ROAR_TALENT: {
    id: 372048,
    name: 'Oppressing Roar',
    icon: 'ability_evoker_oppressingroar',
    maxRanks: 1,
    entryIds: [115607],
    definitionIds: [{ id: 120619, specId: 1473 }],
  },
  OUROBOROS_TALENT: {
    id: 381921,
    name: 'Ouroboros',
    icon: 'ability_evoker_ouroboros',
    maxRanks: 1,
    entryIds: [115555],
    definitionIds: [{ id: 120567, specId: 1468 }],
  },
  OVERAWE_TALENT: {
    id: 374346,
    name: 'Overawe',
    icon: 'ability_evoker_oppressingroar2',
    maxRanks: 1,
    entryIds: [115606],
    definitionIds: [{ id: 120618, specId: 1473 }],
  },
  OVERCLOCK_TALENT: {
    id: 1260647,
    name: 'Overclock',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 1,
    entryIds: [135741],
    definitionIds: [{ id: 140496, specId: 1473 }],
  },
  OVERLORD_TALENT: {
    id: 410260,
    name: 'Overlord',
    icon: 'ability_evoker_overlord',
    maxRanks: 1,
    entryIds: [115513],
    definitionIds: [{ id: 120525, specId: 1473 }],
  },
  PANACEA_TALENT: {
    id: 387761,
    name: 'Panacea',
    icon: 'ability_druid_protectionofthegrove',
    maxRanks: 1,
    entryIds: [115663],
    definitionIds: [{ id: 120675, specId: 1473 }],
  },
  PERILOUS_FATE_TALENT: {
    id: 410253,
    name: 'Perilous Fate',
    icon: 'spell_shadow_lastingafflictions',
    maxRanks: 1,
    entryIds: [115537],
    definitionIds: [{ id: 120549, specId: 1473 }],
  },
  PLOT_THE_FUTURE_TALENT: {
    id: 407866,
    name: 'Plot the Future',
    icon: 'ability_evoker_plotthefuture',
    maxRanks: 1,
    entryIds: [115527],
    definitionIds: [{ id: 120539, specId: 1473 }],
  },
  POTENT_MANA_TALENT: {
    id: 418101,
    name: 'Potent Mana',
    icon: 'spell_magic_managain',
    maxRanks: 1,
    entryIds: [116103],
    definitionIds: [{ id: 121115, specId: 1473 }],
  },
  POWER_NEXUS_TALENT: {
    id: 369908,
    name: 'Power Nexus',
    icon: 'ability_evoker_powernexus',
    maxRanks: 1,
    entryIds: [115582, 115553, 115499],
    definitionIds: [
      { id: 120594, specId: 1467 },
      { id: 120565, specId: 1468 },
      { id: 120511, specId: 1473 },
    ],
  },
  POWER_SWELL_TALENT: {
    id: 370839,
    name: 'Power Swell',
    icon: 'ability_evoker_powernexus2',
    maxRanks: 1,
    entryIds: [115634],
    definitionIds: [{ id: 120646, specId: 1467 }],
  },
  PRESCIENCE_TALENT: {
    id: 409311,
    name: 'Prescience',
    icon: 'ability_evoker_prescience',
    maxRanks: 1,
    entryIds: [115675],
    definitionIds: [{ id: 120687, specId: 1473 }],
  },
  PRIMACY_TALENT: {
    id: 431657,
    name: 'Primacy',
    icon: 'inv_misc_pocketwatch_01',
    maxRanks: 1,
    entryIds: [117548],
    definitionIds: [{ id: 122560, specId: 1473 }],
  },
  PROLONG_LIFE_TALENT: {
    id: 410687,
    name: 'Prolong Life',
    icon: 'ability_evoker_reversion_green',
    maxRanks: 1,
    entryIds: [115678],
    definitionIds: [{ id: 120690, specId: 1473 }],
  },
  PROTRACTED_TALONS_TALENT: {
    id: 369909,
    name: 'Protracted Talons',
    icon: 'ability_evoker_azurestrike',
    maxRanks: 1,
    entryIds: [136559],
    definitionIds: [{ id: 141332, specId: 1473 }],
  },
  PUPIL_OF_ALEXSTRASZA_TALENT: {
    id: 407814,
    name: 'Pupil of Alexstrasza',
    icon: 'ability_evoker_pupilofalexstraza',
    maxRanks: 1,
    entryIds: [115521],
    definitionIds: [{ id: 120533, specId: 1473 }],
  },
  PYRE_TALENT: {
    id: 357211,
    name: 'Pyre',
    icon: 'ability_evoker_pyre',
    maxRanks: 1,
    entryIds: [115647],
    definitionIds: [{ id: 120659, specId: 1467 }],
    essenceCost: 3,
  },
  QUELL_TALENT: {
    id: 351338,
    name: 'Quell',
    icon: 'ability_evoker_quell',
    maxRanks: 1,
    entryIds: [115645, 115690],
    definitionIds: [
      { id: 120657, specId: 1467 },
      { id: 120702, specId: 1473 },
    ],
  },
  REACTIVE_HIDE_TALENT: {
    id: 409329,
    name: 'Reactive Hide',
    icon: 'ability_evoker_reactivehide',
    maxRanks: 1,
    entryIds: [115509],
    definitionIds: [{ id: 120521, specId: 1473 }],
  },
  RECALL_TALENT: {
    id: 371806,
    name: 'Recall',
    icon: 'ability_evoker_recall',
    maxRanks: 1,
    entryIds: [115610],
    definitionIds: [{ id: 120622, specId: 1473 }],
  },
  REFINED_ESSENCE_TALENT: {
    id: 1261452,
    name: 'Refined Essence',
    icon: 'ability_evoker_essenceburststacks',
    maxRanks: 1,
    entryIds: [136051],
    definitionIds: [{ id: 140806, specId: 1473 }],
  },
  REGENERATIVE_CHITIN_TALENT: {
    id: 406907,
    name: 'Regenerative Chitin',
    icon: 'inv12_ability_evoker_blisteringscalesinfinite',
    maxRanks: 1,
    entryIds: [115511],
    definitionIds: [{ id: 120523, specId: 1473 }],
  },
  REGENERATIVE_MAGIC_TALENT: {
    id: 387787,
    name: 'Regenerative Magic',
    icon: 'spell_frost_manarecharge',
    maxRanks: 1,
    entryIds: [115668],
    definitionIds: [{ id: 120680, specId: 1473 }],
  },
  RENEWING_BLAZE_TALENT: {
    id: 374348,
    name: 'Renewing Blaze',
    icon: 'ability_evoker_masterylifebinder_red',
    maxRanks: 1,
    entryIds: [115669],
    definitionIds: [{ id: 120681, specId: 1473 }],
  },
  RENEWING_BREATH_TALENT: {
    id: 371257,
    name: 'Renewing Breath',
    icon: 'ability_evoker_dreambreath',
    maxRanks: 2,
    entryIds: [115574],
    definitionIds: [{ id: 120586, specId: 1468 }],
  },
  RESCUE_TALENT: {
    id: 370665,
    name: 'Rescue',
    icon: 'ability_evoker_flywithme',
    maxRanks: 1,
    entryIds: [115596],
    definitionIds: [{ id: 120608, specId: 1473 }],
  },
  REVERBERATIONS_TALENT: {
    id: 431615,
    name: 'Reverberations',
    icon: 'ability_evoker_giftoftheaspects',
    maxRanks: 1,
    entryIds: [117522],
    definitionIds: [{ id: 122534, specId: 1473 }],
  },
  REVERSION_TALENT: {
    id: 366155,
    name: 'Reversion',
    icon: 'ability_evoker_reversion',
    maxRanks: 1,
    entryIds: [115652],
    definitionIds: [{ id: 120664, specId: 1468 }],
    manaCost: 5500,
  },
  REWIND_TALENT: {
    id: 363534,
    name: 'Rewind',
    icon: 'ability_evoker_rewind',
    maxRanks: 1,
    entryIds: [115651],
    definitionIds: [{ id: 120663, specId: 1468 }],
    manaCost: 13750,
  },
  RICOCHETING_PYROCLAST_TALENT: {
    id: 406659,
    name: 'Ricocheting Pyroclast',
    icon: 'ability_rhyolith_volcano',
    maxRanks: 1,
    entryIds: [115507],
    definitionIds: [{ id: 120519, specId: 1473 }],
  },
  RISING_FURY_1_DEVASTATION_TALENT: {
    id: 1271687,
    name: 'Rising Fury',
    icon: 'inv12_apextalent_evoker_risingfury',
    maxRanks: 1,
    entryIds: [137010],
    definitionIds: [{ id: 141773, specId: 1467 }],
  },
  RISING_FURY_2_DEVASTATION_TALENT: {
    id: 1271796,
    name: 'Rising Fury',
    icon: 'inv12_apextalent_evoker_risingfury',
    maxRanks: 2,
    entryIds: [137009],
    definitionIds: [{ id: 141772, specId: 1467 }],
  },
  RISING_FURY_3_DEVASTATION_TALENT: {
    id: 1271788,
    name: 'Rising Fury',
    icon: 'inv12_apextalent_evoker_risingfury',
    maxRanks: 1,
    entryIds: [137008],
    definitionIds: [{ id: 141771, specId: 1467 }],
  },
  RUBY_EMBERS_TALENT: {
    id: 365937,
    name: 'Ruby Embers',
    icon: 'inv_tradeskillitem_lessersorcerersfire',
    maxRanks: 1,
    entryIds: [115590],
    definitionIds: [{ id: 120602, specId: 1467 }],
  },
  RUBY_ESSENCE_BURST_TALENT: {
    id: 376872,
    name: 'Ruby Essence Burst',
    icon: 'ability_evoker_essenceburst4',
    maxRanks: 1,
    entryIds: [115593],
    definitionIds: [{ id: 120605, specId: 1467 }],
  },
  RUMBLING_EARTH_TALENT: {
    id: 459120,
    name: 'Rumbling Earth',
    icon: 'ability_evoker_geomancy',
    maxRanks: 1,
    entryIds: [115504],
    definitionIds: [{ id: 120516, specId: 1473 }],
  },
  SCARLET_ADAPTATION_TALENT: {
    id: 372469,
    name: 'Scarlet Adaptation',
    icon: 'inv_bijou_red',
    maxRanks: 1,
    entryIds: [115654],
    definitionIds: [{ id: 120666, specId: 1473 }],
  },
  SCINTILLATION_TALENT: {
    id: 370821,
    name: 'Scintillation',
    icon: 'spell_arcane_arcane03',
    maxRanks: 1,
    entryIds: [115636],
    definitionIds: [{ id: 120648, specId: 1467 }],
  },
  SCORCHING_EMBERS_TALENT: {
    id: 370819,
    name: 'Scorching Embers',
    icon: 'spell_fire_burnout',
    maxRanks: 1,
    entryIds: [115622],
    definitionIds: [{ id: 120634, specId: 1467 }],
  },
  SHAPE_OF_FLAME_TALENT: {
    id: 445074,
    name: 'Shape of Flame',
    icon: 'ability_mage_flamecannon',
    maxRanks: 1,
    entryIds: [123404],
    definitionIds: [{ id: 128242, specId: 1468 }],
  },
  SHATTERING_STARS_TALENT: {
    id: 1265802,
    name: 'Shattering Stars',
    icon: 'ability_evoker_chargedblast',
    maxRanks: 1,
    entryIds: [115627],
    definitionIds: [{ id: 120639, specId: 1467 }],
  },
  SLEEP_WALK_TALENT: {
    id: 360806,
    name: 'Sleep Walk',
    icon: 'ability_xavius_dreamsimulacrum',
    maxRanks: 1,
    entryIds: [115601],
    definitionIds: [{ id: 120613, specId: 1473 }],
    manaCost: 2500,
  },
  SLIPSTREAM_TALENT: {
    id: 441257,
    name: 'Slipstream',
    icon: 'ability_dragonriding_barrelroll01',
    maxRanks: 1,
    entryIds: [120123],
    definitionIds: [{ id: 125023, specId: 1473 }],
  },
  SOURCE_OF_MAGIC_TALENT: {
    id: 369459,
    name: 'Source of Magic',
    icon: 'ability_evoker_blue_01',
    maxRanks: 1,
    entryIds: [115658],
    definitionIds: [{ id: 120670, specId: 1473 }],
  },
  SPARK_OF_INSIGHT_TALENT: {
    id: 377099,
    name: 'Spark of Insight',
    icon: 'ability_evoker_essenceburst5',
    maxRanks: 1,
    entryIds: [115575],
    definitionIds: [{ id: 120587, specId: 1468 }],
  },
  SPATIAL_PARADOX_TALENT: {
    id: 406732,
    name: 'Spatial Paradox',
    icon: 'ability_evoker_stretchtime',
    maxRanks: 1,
    entryIds: [125610],
    definitionIds: [{ id: 130442, specId: 1473 }],
  },
  SPELLWEAVERS_DOMINANCE_TALENT: {
    id: 370845,
    name: "Spellweaver's Dominance",
    icon: 'spell_shaman_shockinglava',
    maxRanks: 1,
    entryIds: [115635],
    definitionIds: [{ id: 120647, specId: 1467 }],
  },
  SPIRITUAL_CLARITY_TALENT: {
    id: 376150,
    name: 'Spiritual Clarity',
    icon: 'ability_evoker_spiritbloom',
    maxRanks: 1,
    entryIds: [115544],
    definitionIds: [{ id: 120556, specId: 1468 }],
  },
  STAR_SALVO_TALENT: {
    id: 1265826,
    name: 'Star Salvo',
    icon: 'inv12_ability_mage_arcanesalvo',
    maxRanks: 1,
    entryIds: [115626],
    definitionIds: [{ id: 120638, specId: 1467 }],
  },
  STASIS_TALENT: {
    id: 370537,
    name: 'Stasis',
    icon: 'ability_evoker_stasis',
    maxRanks: 1,
    entryIds: [133527],
    definitionIds: [{ id: 138313, specId: 1468 }],
    manaCost: 10000,
  },
  STRAFING_RUN_TALENT: {
    id: 1266151,
    name: 'Strafing Run',
    icon: 'ability_evoker_blackattunementalt',
    maxRanks: 1,
    entryIds: [115623],
    definitionIds: [{ id: 120635, specId: 1467 }],
  },
  STRETCH_TIME_TALENT: {
    id: 410352,
    name: 'Stretch Time',
    icon: 'ability_evoker_timedilation',
    maxRanks: 1,
    entryIds: [115617],
    definitionIds: [{ id: 120629, specId: 1473 }],
  },
  STRIKE_FROM_ABOVE_TALENT: {
    id: 1267206,
    name: 'Strike from Above',
    icon: 'ability_racial_glide',
    maxRanks: 1,
    entryIds: [136560],
    definitionIds: [{ id: 141333, specId: 1473 }],
  },
  SYMBIOTIC_BLOOM_TALENT: {
    id: 410685,
    name: 'Symbiotic Bloom',
    icon: 'inv_10_herb_seed_magiccolor5',
    maxRanks: 2,
    entryIds: [115515],
    definitionIds: [{ id: 120527, specId: 1473 }],
  },
  TAILWIND_TALENT: {
    id: 375556,
    name: 'Tailwind',
    icon: 'ability_skyreach_wind',
    maxRanks: 1,
    entryIds: [115598],
    definitionIds: [{ id: 120610, specId: 1473 }],
  },
  TECTONIC_LOCUS_TALENT: {
    id: 408002,
    name: 'Tectonic Locus',
    icon: '6bf_explosive_shard',
    maxRanks: 1,
    entryIds: [115500],
    definitionIds: [{ id: 120512, specId: 1473 }],
  },
  TEMPORALITY_TALENT: {
    id: 431873,
    name: 'Temporality',
    icon: 'ability_evoker_return',
    maxRanks: 1,
    entryIds: [117532],
    definitionIds: [{ id: 122544, specId: 1473 }],
  },
  TEMPORAL_ANOMALY_TALENT: {
    id: 373861,
    name: 'Temporal Anomaly',
    icon: 'ability_evoker_temporalanomaly',
    maxRanks: 1,
    entryIds: [115561],
    definitionIds: [{ id: 120573, specId: 1468 }],
    manaCost: 18750,
  },
  TEMPORAL_ARTIFICER_TALENT: {
    id: 381922,
    name: 'Temporal Artificer',
    icon: 'ability_evoker_rewind',
    maxRanks: 1,
    entryIds: [115570],
    definitionIds: [{ id: 120582, specId: 1468 }],
  },
  TEMPORAL_BARRIER_TALENT: {
    id: 1291636,
    name: 'Temporal Barrier',
    icon: 'ability_evoker_bronze_01',
    maxRanks: 1,
    entryIds: [115563],
    definitionIds: [{ id: 120575, specId: 1468 }],
    manaCost: 18750,
  },
  TEMPORAL_BURST_TALENT: {
    id: 431695,
    name: 'Temporal Burst',
    icon: 'ability_evoker_essenceburst5',
    maxRanks: 1,
    entryIds: [117552],
    definitionIds: [{ id: 122564, specId: 1473 }],
  },
  TEMPORAL_COMPRESSION_TALENT: {
    id: 362874,
    name: 'Temporal Compression',
    icon: 'ability_evoker_rewind2',
    maxRanks: 1,
    entryIds: [115543],
    definitionIds: [{ id: 120555, specId: 1468 }],
  },
  TEMPO_CHARGED_TALENT: {
    id: 1237978,
    name: 'Tempo Charged',
    icon: 'classicon_evoker_preservation',
    maxRanks: 1,
    entryIds: [115567],
    definitionIds: [{ id: 120579, specId: 1468 }],
  },
  TERROR_OF_THE_SKIES_TALENT: {
    id: 371032,
    name: 'Terror of the Skies',
    icon: 'ability_evoker_terroroftheskies',
    maxRanks: 1,
    entryIds: [115656],
    definitionIds: [{ id: 120668, specId: 1473 }],
  },
  TIMELESSNESS_TALENT: {
    id: 412710,
    name: 'Timelessness',
    icon: 'ability_evoker_timelessness',
    maxRanks: 1,
    entryIds: [115679],
    definitionIds: [{ id: 120691, specId: 1473 }],
  },
  TIMELESS_MAGIC_TALENT: {
    id: 376240,
    name: 'Timeless Magic',
    icon: 'inv_artifact_xp05',
    maxRanks: 2,
    entryIds: [115568],
    definitionIds: [{ id: 120580, specId: 1468 }],
  },
  TIME_CONVERGENCE_TALENT: {
    id: 431984,
    name: 'Time Convergence',
    icon: 'ability_evoker_plotthefuture',
    maxRanks: 1,
    entryIds: [117786],
    definitionIds: [{ id: 122798, specId: 1473 }],
  },
  TIME_DILATION_TALENT: {
    id: 357170,
    name: 'Time Dilation',
    icon: 'ability_evoker_timedilation',
    maxRanks: 1,
    entryIds: [115650],
    definitionIds: [{ id: 120662, specId: 1468 }],
    manaCost: 5500,
  },
  TIME_LORD_TALENT: {
    id: 372527,
    name: 'Time Lord',
    icon: 'ability_evoker_innatemagic4',
    maxRanks: 2,
    entryIds: [115558],
    definitionIds: [{ id: 120570, specId: 1468 }],
  },
  TIME_OF_NEED_TALENT: {
    id: 368412,
    name: 'Time of Need',
    icon: 'ability_evoker_masterylifebinder_bronze',
    maxRanks: 1,
    entryIds: [115564],
    definitionIds: [{ id: 120576, specId: 1468 }],
  },
  TIME_SKIP_TALENT: {
    id: 404977,
    name: 'Time Skip',
    icon: 'ability_evoker_timeskip',
    maxRanks: 1,
    entryIds: [115533],
    definitionIds: [{ id: 120545, specId: 1473 }],
  },
  TIME_SPIRAL_TALENT: {
    id: 374968,
    name: 'Time Spiral',
    icon: 'ability_evoker_timespiral',
    maxRanks: 1,
    entryIds: [115666],
    definitionIds: [{ id: 120678, specId: 1473 }],
  },
  TIP_THE_SCALES_TALENT: {
    id: 370553,
    name: 'Tip the Scales',
    icon: 'ability_evoker_tipthescales',
    maxRanks: 1,
    entryIds: [115665],
    definitionIds: [{ id: 120677, specId: 1473 }],
  },
  TITANIC_PRECISION_TALENT: {
    id: 445625,
    name: 'Titanic Precision',
    icon: 'inv_10_misc_titansspark_shadowflame',
    maxRanks: 1,
    entryIds: [117517],
    definitionIds: [{ id: 122529, specId: 1468 }],
  },
  TITANIC_WRATH_TALENT: {
    id: 386272,
    name: 'Titanic Wrath',
    icon: 'spell_fireresistancetotem_01',
    maxRanks: 1,
    entryIds: [115578],
    definitionIds: [{ id: 120590, specId: 1467 }],
  },
  TITANS_GIFT_TALENT: {
    id: 443264,
    name: "Titan's Gift",
    icon: 'spell_fireresistancetotem_01',
    maxRanks: 1,
    entryIds: [123293],
    definitionIds: [{ id: 128171, specId: 1468 }],
  },
  TOMORROW_TODAY_TALENT: {
    id: 412723,
    name: 'Tomorrow, Today',
    icon: 'ability_evoker_rewind2',
    maxRanks: 1,
    entryIds: [115687],
    definitionIds: [{ id: 120699, specId: 1473 }],
  },
  TRAILBLAZER_TALENT: {
    id: 444849,
    name: 'Trailblazer',
    icon: 'ability_deathwing_fierygrip',
    maxRanks: 1,
    entryIds: [117534],
    definitionIds: [{ id: 122546, specId: 1468 }],
  },
  TWIN_ECHOES_TALENT: {
    id: 1242031,
    name: 'Twin Echoes',
    icon: 'inv_ability_evoker_greaterecho',
    maxRanks: 1,
    entryIds: [115571],
    definitionIds: [{ id: 120583, specId: 1468 }],
  },
  TWIN_FLAME_TALENT: {
    id: 1265979,
    name: 'Twin Flame',
    icon: 'ability_evoker_infernosblessing',
    maxRanks: 1,
    entryIds: [136056],
    definitionIds: [{ id: 140811, specId: 1468 }],
  },
  TWIN_GUARDIAN_TALENT: {
    id: 370888,
    name: 'Twin Guardian',
    icon: 'inv_misc_volatileair',
    maxRanks: 1,
    entryIds: [115595],
    definitionIds: [{ id: 120607, specId: 1473 }],
  },
  TYRANNY_TALENT: {
    id: 376888,
    name: 'Tyranny',
    icon: 'ability_evoker_dragonrage2',
    maxRanks: 1,
    entryIds: [115640],
    definitionIds: [{ id: 120652, specId: 1467 }],
  },
  UNRAVEL_TALENT: {
    id: 1264378,
    name: 'Unravel',
    icon: 'ability_evoker_unravel',
    maxRanks: 1,
    entryIds: [115616],
    definitionIds: [{ id: 120628, specId: 1473 }],
  },
  UNRELENTING_SIEGE_TALENT: {
    id: 441246,
    name: 'Unrelenting Siege',
    icon: 'ability_siege_engineer_superheated',
    maxRanks: 1,
    entryIds: [117531],
    definitionIds: [{ id: 122543, specId: 1473 }],
  },
  UNSHAKABLE_TALENT: {
    id: 1239581,
    name: 'Unshakable',
    icon: 'ability_evoker_masterygiantkiller',
    maxRanks: 1,
    entryIds: [115549],
    definitionIds: [{ id: 120561, specId: 1468 }],
  },
  UNYIELDING_DOMAIN_TALENT: {
    id: 412733,
    name: 'Unyielding Domain',
    icon: 'spell_shaman_stormearthfire',
    maxRanks: 1,
    entryIds: [115501],
    definitionIds: [{ id: 120513, specId: 1473 }],
  },
  UPHEAVAL_TALENT: {
    id: 396286,
    name: 'Upheaval',
    icon: 'ability_evoker_upheaval',
    maxRanks: 1,
    entryIds: [115502],
    definitionIds: [{ id: 120514, specId: 1473 }],
  },
  VERDANT_EMBRACE_TALENT: {
    id: 360995,
    name: 'Verdant Embrace',
    icon: 'ability_evoker_rescue',
    maxRanks: 1,
    entryIds: [115655],
    definitionIds: [{ id: 120667, specId: 1473 }],
    manaCost: 6000,
  },
  VOLATILITY_TALENT: {
    id: 369089,
    name: 'Volatility',
    icon: 'spell_fire_ragnaros_lavabolt',
    maxRanks: 2,
    entryIds: [115591],
    definitionIds: [{ id: 120603, specId: 1467 }],
  },
  VOLCANISM_TALENT: {
    id: 406904,
    name: 'Volcanism',
    icon: 'spell_fire_volcano',
    maxRanks: 1,
    entryIds: [115505],
    definitionIds: [{ id: 120517, specId: 1473 }],
  },
  WALLOPING_BLOW_TALENT: {
    id: 387341,
    name: 'Walloping Blow',
    icon: 'inv_misc_monsterscales_06',
    maxRanks: 1,
    entryIds: [115594],
    definitionIds: [{ id: 120606, specId: 1473 }],
  },
  WARP_TALENT: {
    id: 429483,
    name: 'Warp',
    icon: 'ability_evoker_spatialparadox',
    maxRanks: 1,
    entryIds: [117545],
    definitionIds: [{ id: 122557, specId: 1473 }],
  },
  WINGLEADER_TALENT: {
    id: 441206,
    name: 'Wingleader',
    icon: 'ability_racial_soar',
    maxRanks: 1,
    entryIds: [117550],
    definitionIds: [{ id: 122562, specId: 1473 }],
  },
  WINGS_OF_LIBERTY_TALENT: {
    id: 1241704,
    name: 'Wings of Liberty',
    icon: 'ability_evoker_masterylifebinder',
    maxRanks: 1,
    entryIds: [133503],
    definitionIds: [{ id: 138289, specId: 1468 }],
  },
  ZEPHYR_TALENT: {
    id: 374227,
    name: 'Zephyr',
    icon: 'ability_evoker_hoverblack',
    maxRanks: 1,
    entryIds: [115661],
    definitionIds: [{ id: 120673, specId: 1473 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_EVOKER };
